import React, { useState, useRef, useEffect } from 'react';
import Fuse from 'fuse.js';
import PropTypes from 'prop-types';
import './search-futures-options.m.css';
import { MaginifyIcon, CloseIcon } from '../../../../../atoms/material-icons';

const SearchFuturesOptions = ({ onStockSearch, onCloseSearch }) => {
  const [stocksData, setStocksData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [showSearchList, setShowSearchList] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    const getStocksListData = async () => {
      try {
        const stockDetailsResponse = await fetch('/foapi/future/getSearchFilter');

        const stockDetailsData = await stockDetailsResponse.json();
        setStocksData(stockDetailsData?.data);
        setSearchQuery('NIFTY 50');
      } catch (error) {
        console.log('Error in searching stocks', error);
      }
    };
    getStocksListData();
  }, []);

  const fuse = new Fuse(stocksData, {
    keys: ['name'],
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 50,
    maxPatternLength: 32,
    minMatchCharLength: 2,
  });

  const onSearch = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    if (value) {
      const results =
        fuse &&
        fuse?._docs.filter(
          (item) =>
            item?.name?.toLowerCase().includes(value.toLowerCase()) ||
            item?.item?.name?.toLowerCase().includes(value.toLowerCase()),
        );
      setSearchResult(results);
      setShowSearchList(true);
    }
  };
  const suggestionSelected = (value) => {
    const target = value?.item || value;
    setSearchQuery(target?.name.toUpperCase());
    onStockSearch(target?.symbol);
    setSearchResult([]);
    setShowSearchList(false);
  };

  const clearSearch = () => {
    setSearchQuery('NIFTY 50');
    onStockSearch('NIFTY%2050');
    setSearchResult([]);
    setShowSearchList(false);
    onCloseSearch(true);
  };
  // Hide the search list when clicking outside the component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchList(false);
      }
    };
    const handleScroll = () => {
      setShowSearchList(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [searchRef]);

  return (
    <div styleName="search-stocks" ref={searchRef}>
      <input
        id="inputStock"
        placeholder="Search Stocks"
        list="stocks"
        value={searchQuery}
        onChange={(event) => onSearch(event)}
        onFocus={() => {
          searchQuery === 'NIFTY 50' ? setSearchQuery('') : setSearchQuery(searchQuery);
          setSearchResult(stocksData);
          setShowSearchList(true);
        }}
      />

      <ul styleName={showSearchList ? 'show' : 'hide'}>
        {searchResult?.length > 0 ? (
          searchResult?.map((item, index) => (
            <li key={index} onClick={() => suggestionSelected(item)}>
              {item.item ? item.item.name.toUpperCase() : item.name.toUpperCase()}
            </li>
          ))
        ) : (
          <li>No result found</li>
        )}
      </ul>

      <div styleName="search-icon">
        <MaginifyIcon />
      </div>
      {searchQuery?.length >= 0 && (searchQuery !== 'NIFTY 50' || searchQuery !== 'nifty%2050') && (
        <div styleName="close-icon" onClick={() => clearSearch()}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
};

SearchFuturesOptions.propTypes = {
  onStockSearch: PropTypes.func,
  onCloseSearch: PropTypes.func,
};

export default SearchFuturesOptions;
